export const formatNegativeValues = (value) => value<0?`(${-value})`:value